import {Component, OnInit} from '@angular/core';
import {FirebaseService} from '../../../../../../service/firebase/firebase.service';
import {Biowetter} from '../../../../../../model/vorhersagen/biowetter';
import {BundesLandName} from '../../../../../../model/component/bundesland';
import {BundeslandFilterService} from '../../../../../../service/bundeslandFilter/bundesland-filter.service';

@Component({
  selector: 'app-biowetter',
  templateUrl: './biowetter.component.html',
  styleUrls: ['./biowetter.component.css']
})
export class BiowetterComponent implements OnInit {

  public bundeslaenderTabs: string[] = [];

  private biowetterList: Biowetter[] = [];

  constructor(private firebaseService: FirebaseService,
              private bundeslandFilterService: BundeslandFilterService) {
  }

  ngOnInit(): void {
    this.firebaseService.getBiowetter().subscribe(biowetterList => this.biowetterList = biowetterList);
    this.bundeslandFilterService.onFilterUpdated.subscribe(bundeslaender => {
      this.updateBundeslaenderTabs(bundeslaender);
    });
    this.updateBundeslaenderTabs(this.bundeslandFilterService.getSelectedBundesLaender());
  }

  getBiowetterForBundesland(bundeslandName: string): Biowetter[] {
    return this.biowetterList.filter(biowetter => this.belongsToBundesland(biowetter, bundeslandName));
  }

  private updateBundeslaenderTabs(bundeslaender) {
    if (this.bundeslandFilterService.hasDeutschlandFilterActive()) {
      this.bundeslaenderTabs = Object.values(BundesLandName);
    } else {
      this.bundeslaenderTabs = bundeslaender.map(bundesland => bundesland.name);
    }
  }

  private belongsToBundesland(biowetter: Biowetter, bundeslandName: string): boolean {
    return biowetter.bundeslaender
      .map(bundesland => bundesland.name)
      .includes(bundeslandName === BundesLandName.HB ? 'Bremen' : bundeslandName);
  }

}
